import { FC } from 'react';
import parse, { DOMNode, domToReact, Element } from 'html-react-parser';
import DOMPurify from 'dompurify';

import { ExternalLink } from '@app/components';

interface SafeHTMLRendererProps {
  rawHtmlString: string;
}

export const SanitizedTextWithLinks: FC<SafeHTMLRendererProps> = ({
  rawHtmlString,
}) => {
  const sanitizedHtml = DOMPurify.sanitize(rawHtmlString, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href'],
  });
  const parsedContent = parse(sanitizedHtml, {
    replace: node => {
      if (node instanceof Element && node.name === 'a') {
        const href = node.attribs.href;
        const children = domToReact(node.children as DOMNode[]);

        return <ExternalLink href={href}>{children}</ExternalLink>;
      }

      return null;
    },
  });

  return <div data-auto="sanitized-text-with-links">{parsedContent}</div>;
};
